import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AccessManager } from './access-manager';
import { UIErrorHandler } from '../../../core/uiErrorHandler';

@Component({
  selector: 'app-access-manager',
  templateUrl: './access-manager.component.html',
  standalone: false,
})
export class AccessManagerComponent {
  @Input() namespace: string;
  @Input() validatePageAccess: boolean = true;
  @Input() redirectPath: string = '/restricted';
  @Output() restrictedCallback = new EventEmitter<void>();

  allowAccess: boolean = true;

  constructor(
    private accessManager: AccessManager,
    private uiErrorHandler: UIErrorHandler,
  ) {
    this.namespace = '';
  }

  ngOnInit() {
    if (this.namespace && this.namespace != '') {
      this.accessManager
        .getUserAccess(this.namespace)
        .then((access) => {
          this.allowAccess = access[this.namespace];
          if (this.validatePageAccess && !this.allowAccess) {
            this.restrictedCallback.emit();
          }
        })
        .catch((message) => {
          this.uiErrorHandler.handleError(message);
        });
    } else {
      throw 'namespace is not defined';
    }
  }
}
